import Vue from 'vue'
import Vuex from 'vuex';
import i18n from '../plugins/i18n';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        //get from cookie
        language: window.localStorage.getItem('locale') || 'ja',
    },
    mutations: {
        setLanguage(state, language) {
            state.language = language;
            i18n.locale =language;
            window.localStorage.setItem('locale', language);
        },
    },
    actions: {
        setLanguage({ commit }, language) {
            commit('setLanguage', language);
        },
    },
    getters: {
        getLanguage(state) {
            return state.language
        },
    },
});